import { Link } from "components/elements";
import {
  GrabsonIcon,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "components/layout";

import { TEXTS } from "../constants";
import { ReleaseStageSchedule } from "../types";
import { getScheduleWindow } from "../utils";
import styles from "./Schedules.scss";
import { ScheduleTime } from "./ScheduleTime";

export function ScheduleTable({
  now,
  rows,
}: {
  now: Date;
  rows: readonly ReleaseStageSchedule[];
}) {
  return (
    <div className={styles.scheduleTable}>
      <Table>
        <TableHeader>
          <TableHeaderColumn className={styles.stageColumn}>
            {TEXTS.SCHEDULES_TABLE.RS_COL}
          </TableHeaderColumn>
          <TableHeaderColumn className={styles.pullColumn}>
            {TEXTS.SCHEDULES_TABLE.LAST_PULL_COL}
          </TableHeaderColumn>
          <TableHeaderColumn className={styles.nextPullColumn}>
            {TEXTS.SCHEDULES_TABLE.NEXT_PULL_COL}
          </TableHeaderColumn>
        </TableHeader>
        <TableBody>
          {rows.map((row) => {
            const { stage, schedule, jobStatusUrl } = row;
            const { lastPull, nextPull } = getScheduleWindow(now, schedule);
            const hasScheduleWindow = lastPull && nextPull;

            return (
              <TableRow key={stage}>
                <TableRowColumn columnClass={styles.stageColumn}>
                  <strong>{stage}</strong>
                </TableRowColumn>
                <TableRowColumn
                  className={styles.lastPull}
                  columnClass={styles.pullColumn}
                >
                  {hasScheduleWindow ? (
                    <>
                      <ScheduleTime date={lastPull} />
                      {jobStatusUrl && (
                        <Link
                          className={styles.jobStatus}
                          href={jobStatusUrl}
                          target="_blank"
                          dataTestId={`job-status-${stage}`}
                        >
                          {TEXTS.SCHEDULES_TABLE.JOB_STATUS}
                        </Link>
                      )}
                    </>
                  ) : (
                    <span className={styles.pending}>
                      <GrabsonIcon name="pending" size="normal" />
                      {TEXTS.SCHEDULES_TABLE.PENDING}
                    </span>
                  )}
                </TableRowColumn>
                <TableRowColumn columnClass={styles.nextPullColumn}>
                  {hasScheduleWindow ? (
                    <ScheduleTime date={nextPull} now={now} />
                  ) : (
                    <span className={styles.pending}>
                      <GrabsonIcon name="pending" size="normal" />
                      {TEXTS.SCHEDULES_TABLE.PENDING}
                    </span>
                  )}
                </TableRowColumn>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
